import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';

export type AvailabilityStatus = 'PENDING' | 'AVAILABLE' | 'NOT_AVAILABLE';
export interface SelectionSource {
  tournamentId: string;
  tournamentName: string;
  eventId: string;
  eventName: string;
  teamId?: string;
  place?: number;
  result?: any;
  method: 'PLACES' | 'MANUAL';
}
export interface SelectionRule {
  tournamentId: string;
  mode: 'PLACES' | 'MANUAL';
  places?: number[];
  eventIds?: string[];
}
export interface AvailabilityAthlete {
  birthday?: string;
  id?: string;
  userId: string;
  permissionId: string;
  firstName: string;
  lastName: string;
  schoolId: string;
  schoolName: string;
  sources: SelectionSource[];
  availability: AvailabilityStatus;
  version: number;
  requested: boolean;
  events: Array<{id: string; name: string; startTime: string}>;
}
export const athleteKey = (item: {userId: string; permissionId: string}) => `${item.userId}:${item.permissionId}`;

export function availabilityOptions(current: AvailabilityStatus, isUnion: boolean): AvailabilityStatus[] {
  if (isUnion) return ['PENDING', 'AVAILABLE', 'NOT_AVAILABLE'];
  if (current === 'NOT_AVAILABLE') return ['NOT_AVAILABLE'];
  if (current === 'AVAILABLE') return ['AVAILABLE', 'NOT_AVAILABLE'];
  return ['PENDING', 'AVAILABLE', 'NOT_AVAILABLE'];
}
export const statusLabel = (status: AvailabilityStatus) => ({PENDING: 'Pending', AVAILABLE: 'Available', NOT_AVAILABLE: 'Not available'}[status]);
export const formatLondonDate = (value: string | Date) => value ? new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/London', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZoneName: 'short'
}).format(value instanceof Date ? value : new Date(value)) : 'Not set';
export const errorMessage = (error: any) => error?.response?.data?.message || error?.response?.data?.error?.message || error?.message || 'Unable to complete this action. Please try again.';

export async function highLevelApi(user: AppUser, tournamentId: string, path: string, body?: any, params?: any) {
  const url = `${window.apiBase}/i/schools/${user.activeSchoolId}/tournaments/${tournamentId}/highLevel/${path}`;
  const config = {headers: {usid: user.roleSessionKey}, params};
  return (body === undefined ? await axios.get(url, config) : await axios.post(url, body, config)).data;
}
export async function availabilityApi(user: AppUser, tournamentId: string, unionId: string | undefined, path = '', body?: any, params?: any) {
  if (!unionId) return highLevelApi(user, tournamentId, `availability${path}`, body, params);
  const url = `${window.apiBase}/i/schools/${user.activeSchoolId}/highLevelTournamentAvailability/${unionId}/${tournamentId}${path}`;
  const config = {headers: {usid: user.roleSessionKey}, params};
  return (body === undefined ? await axios.get(url, config) : await axios.post(url, body, config)).data;
}
export async function availabilityInbox(user: AppUser, page = 0, activeOnly = false, period?: string) {
  return (await axios.get(`${window.apiBase}/i/schools/${user.activeSchoolId}/highLevelTournamentAvailability`, {headers: {usid: user.roleSessionKey}, params: {page, activeOnly, period}})).data;
}
